module.exports = __webpack_public_path__ + "img/info-arrow.43cba440.svg";